export default {
    VALID_KANJI_FACILITY_NAME: "Please add valid kanji facility name",
    VALID_KANA_FACILITY_NAME: "Please add valid kana facility name",
    VALID_FACILITY_NAME: "Please add valid facility name",
    PROVIDE_KANJI_FACILITY_NAME: "Please enter kanji facility name",
    VALID_INTEGRATED_CODE: "Please add valid integrated code",
    VALID_ADDRESS: "Please add valid address",
    VALID_NUMBER: "Please add valid number",
    VALID_POSTAL_CODE: "Please add valid postal code",
    VALID_NAME: "Please add valid name",
    PROVIDE_CUSTOMER_TYPE: "Please select customer type",
    PROVIDE_PREFECTURE: "Please select prefecture",
    PROVIDE_CITY: "Please select city",
    PROVIDE_SUBURB: "Please select suburb",
    PROVIDE_STREET: "Please select street",
    VALID_POSTAL_CODE: "Please add valid postal code",
    PROVIDE_KANJI_ADDRESS: "Please enter kanji address",
    VALID_KANJI_ADDRESS: "Please add valid kanji address",
    VALID_KANA_ADDRESS: "Please add valid kana address",
    VALID_KANJI_REPRESENTATIVE: "Please add valid kanji representative name",
    VALID_KANA_REPRESENTATIVE: "Please add valid kana representative name",
    VALID_NUMBER_OF_BEDS: "Please enter valid number of beds",
    PROVIDE_NUMBER_OF_BEDS: "Please enter number of beds",
    PROVIDE_SPECIALITY: "Please select atleast one speciality",
    VALID_REMARKS: "Please add valid remarks (no line breaks)",
    VALID_KANJI_CUSTOMER_NAME: "Please add valid kanji customer name",
    VALID_KANA_CUSTOMER_NAME: "Please add valid kana customer name",
    VALID_KANJI_PHARMACIST_NAME: "Please add valid kanji pharmacist name",
    VALID_KANA_PHARMACIST_NAME: "Please add valid kana pharmacist name",
    VALID_KANJI_PERSON_NAME: "Please add valid kanji person name",
    VALID_KANA_PERSON_NAME: "Please add valid kana person name",
    VALID_KANJI_NAME: "Please add valid kanji name",
    VALID_KANA_NAME: "Please add valid kana name",
    PROVIDE_KANJI_NAME: "Please enter kanji name",
    PROVIDE_AFFILIATED_CUSTOMER_CODE: "Please select affiliated organization customer code",
    PROVIDE_NUMBER: "Please enter number",
    VALID_KANJI_PHARMACIST: "Please add valid kanji pharmacist name",
    VALID_KANA_PHARMACIST: "Please add valid kana pharmacist name",
    PROVIDE_BU: "Please select BU",
    PROVIDE_DIVISION: "Please select division",
    PROVIDE_BRANCH: "Please select branch",
    PROVIDE_SALES_OFFICE: "Please select sales office",
    PROVIDE_TERRITORY: "Please select territory",
    PROVIDE_MR: "Please select MR",
    PROVIDE_DURATION: "Please select duration"
}